import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "asVideoConsultationsCard_wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "asVideoConsultationsCard_icon" }, null, -1)
const _hoisted_4 = { class: "asVideoConsultationsCard_actions" }
const _hoisted_5 = { class: "asVideoConsultationsCard_tip" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "asVideoConsultationsCard_circle"
}
const _hoisted_8 = { class: "asVideoConsultationsCard_wrapper" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "asVideoConsultationsCard_avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/avatar.png",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "asVideoConsultationsCard_avatar_icon" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "asVideoConsultationsCard_avatar_icon_wrapper" })
  ])
], -1)
const _hoisted_10 = { class: "asVideoConsultationsCard_actions" }
const _hoisted_11 = {
  key: 0,
  class: "asVideoConsultationsCard_tip"
}
const _hoisted_12 = {
  key: 1,
  class: "asVideoConsultationsCard_tip"
}
const _hoisted_13 = {
  key: 2,
  class: "asVideoConsultationsCard_dateTime"
}
const _hoisted_14 = { class: "-date" }
const _hoisted_15 = { class: "-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.type === 'buy')
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "asVideoConsultationsCard",
          href: _ctx.link,
          target: "_blank",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink(_ctx.link)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('videoConsultations.buyConsultation')), 1)
            ])
          ])
        ], 8, _hoisted_1))
      : (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: _ctx.link,
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("div", {
              class: _normalizeClass(["asVideoConsultationsCard", `-${_ctx.videoConsultation.status ? _ctx.videoConsultation.status.toLowerCase() : ''}`]),
              onClick: navigate
            }, [
              (_ctx.isApproved(_ctx.videoConsultation.status))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  (_ctx.isCreatedOrCanceled(_ctx.videoConsultation.status))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t('videoConsultations.orderingOnConsultation')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isPlanned(_ctx.videoConsultation.status))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('videoConsultations.waitApprove')), 1))
                    : _createCommentVNode("", true),
                  (_ctx.isApproved(_ctx.videoConsultation.status) || _ctx.isDoneOrRefund(_ctx.videoConsultation.status))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.getDate(_ctx.videoConsultation.startDateTime)), 1),
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.getTime(_ctx.videoConsultation.startDateTime)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 10, _hoisted_6)
          ]),
          _: 1
        }, 8, ["to"]))
  ]))
}